import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../redux/hooks";
import { rootState } from "../../../../../redux/store";
import useFeaturesFilterData from "./useFeaturesFilterData";
import { IFeaturesConfig, IFeature, IFeaturesEditable, IFeaturesEditablePathSource } from "../../../../../interface/interfaces";
import useUniqueTools from "./useUniqueTools";
import { selectorToolConfig } from "../redux/selector";

const useConfigureCollectedTools = () => {
    const { featuresData, featuresLoading, featuresError } = useAppSelector((state: rootState) => state.featuresConfig);
    const { isChecked } = useAppSelector((state: rootState) => state.featuresFilter);

    const {allPaths, userSettingsFilePath} = useAppSelector(selectorToolConfig);

    const { featuresDataFilter, isValid, error } = useFeaturesFilterData(featuresData, isChecked);

        const [tools, setTools] = useState<IFeaturesEditable[]>([]);
        const [index, setIndex] = useState<number[]>([]);

    const { uniqueTools, setSeenTools } = useUniqueTools();

    const getFilePath = (tool: string) => {
        const pathObj = allPaths.allPaths.find((path) => path.tool === tool);
        return pathObj ? pathObj.file_path : '';
    };
    

    useEffect(() => {
        const getUniqueToolsConfig = featuresDataFilter.map((feature: IFeaturesConfig) => uniqueTools(feature)).flat();

        setTools(getUniqueToolsConfig.map((item: IFeature) => ({ ...item, isEditable: false })));
    }, [featuresDataFilter, isChecked]);

    useEffect(() => {
        setSeenTools(new Set<string>());
    }, [isChecked]);
    
        const applyChanges = () => {
            const newTools = [...tools];
    
            newTools.forEach((newToolItem: IFeaturesEditable) => {
                newToolItem.isEditable = false;
            });
    
            setTools(newTools);
            setIndex([]);
    
            //BITNO
            // Ako želite da pošaljete ažurirane podatke na backend, uradite to ovde
            // sendUpdatedDataToBackend(newFields[index]);
        };
    
    const collectedTools: IFeaturesEditablePathSource[] = tools.map((tool: IFeaturesEditable) => {
        const editUserPath = getFilePath(tool.Tool);
        return {...tool, DefaultLocation: editUserPath ? editUserPath : tool.DefaultLocation, isDefaultLocation: editUserPath ? false : true};
    })

    return {featuresDataFilter, collectedTools, tools, setTools, index, setIndex, applyChanges, isChecked, featuresLoading, featuresError, userSettingsFilePath, isValid, error }
}

export default useConfigureCollectedTools;
